import storage from "redux-persist/lib/storage";
import { createStore, applyMiddleware, compose, Store } from "redux";
import { persistReducer, persistStore, Persistor } from "redux-persist";
import { createEpicMiddleware } from "redux-observable";

import allReducers from "./reducer";
import epic from "./epic";
import dependencies from "./dependencies";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const epicMiddleware = createEpicMiddleware({
  dependencies,
});

const configureStore = (): // preloadedState: object = {},
{ store: Store; persistor: Persistor } => {
  const persistedReducer = persistReducer(persistConfig, allReducers);
  const middlewares = [epicMiddleware];
  const store = createStore(
    persistedReducer,
    compose(applyMiddleware(...middlewares))
    // @ts-ignore
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );

  epicMiddleware.run(epic);
  const persistor = persistStore(store);
  return { store, persistor };
};

export default configureStore;
